import { createSlice, PayloadAction } from '@reduxjs/toolkit'


interface WalletState {
  loaded: boolean
  isAuthorized: boolean
}

const initialState: WalletState = {
  loaded: false,
  isAuthorized: false,
}


export const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setLoaded: (state, action: PayloadAction<boolean>) => {
      state.loaded = action.payload
    },
    authorize: (state) => {
      state.isAuthorized = true
    },
    deauthorize: (state) => {
      state.isAuthorized = false
    },
  },
})


export const { setLoaded, authorize, deauthorize } = walletSlice.actions

export default walletSlice.reducer
